import { useEffect, useState } from 'react';

import { getInvoiceInformationList } from '../../../api/invoice';


export const useRecordsList = (invoiceNum, rerender) => {
  const [data, updateData] = useState([]);
  const [loading, updateLoading] = useState(false);

  useEffect(() => {
    updateData([]);

    const fetchData = async () => {
      updateLoading(true);
      const response = await getInvoiceInformationList({ invoiceNumber: invoiceNum });
      updateLoading(false);

      if (response) {
        updateData(response);
      }
    };

    fetchData();
  }, [invoiceNum, rerender]);

  return [data, loading];
};
